module.exports = __webpack_public_path__ + "pc/img/designer.c7ab4714.webp";